<template>
  <div>
    <l-map
      ref="map"
      :zoom="zoom"
      :center="center">
      <l-tile-layer :url="url"></l-tile-layer>
      <l-polygon
        :latLngs="latlngs"
        v-if="!isCircle">
      </l-polygon>
      <l-marker
        :lat-lng="marker">
        <l-popup :content="popup">
        </l-popup>
      </l-marker>
      <l-circle
        :lat-lng="coordinates"
        :radius="radius"
        v-if="isCircle">
      </l-circle>
    </l-map>
  </div>
</template>
<script>
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LPopup, LCircle, LPolygon } from 'vue2-leaflet';
import { get, values } from 'lodash';

export default {
  name: 'Leaflet',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LCircle,
    LPolygon,
  },
  props: {
    zoom: {
      type: Number,
      default: 15,
      require: false,
    },
    center: {
      type: Array,
      default() {
        return [0, 0];
      },
    },
    url: {
      type: String,
      default: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      require: false,
    },
    marker: {
      type: Object,
      default() {
        return { lng: 0, lat: 0 };
      },
      require: false,
    },
    popup: {
      type: String,
      default: '',
    },
    isCircle: {
      type: Boolean,
      default: false,
    },
    coordinates: {
      default: () => [0, 0],
    },
    radius: {
      type: Number,
      default: 200,
    },
    latlngs: {
      default: () => [],
    },
  },
  data() {
    return {
      options: {
        style() {
          return {
            weight: 2,
            color: '#3388ff',
            opacity: 1,
            fillColor: '#93c5e5',
            fillOpacity: 0.5,
          };
        },
      },
      icons: {
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-icon-2x.png',
        iconUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-icon.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-shadow.png',
      },
    };
  },
  created() {
    /* eslint no-underscore-dangle: 0 */
    delete L.Icon.Default.prototype._getIconUrl;

    const { iconRetinaUrl, iconUrl, shadowUrl } = this.icons;
    L.Icon.Default.imagePath = '';
    L.Icon.Default.mergeOptions({
      iconRetinaUrl,
      iconUrl,
      shadowUrl,
    });

    // fix if use wrong coordinates
    setTimeout(() => {
      const firstCoordinate = get(this.latlngs, '0.0') || [0, 0];
      const inValidCoordinates = firstCoordinate[0] > 0;

      if (inValidCoordinates) {
        this.latlngs = this.latlngs.map((coordinates) => {
          const switchedCoordinates = coordinates.map(coordinate => (
            [coordinate[1], coordinate[0]]
          ));
          return switchedCoordinates;
        });

        const polygon = L.polygon(this.latlngs);
        const center = polygon.getBounds().getCenter();
        this.center = values(center);
        this.marker = center;
      }
    }, 1e3);
  },
};
</script>
<style lang="sass">
@import "~leaflet/dist/leaflet.css";
.leaflet-control-container
  height: 500px;
</style>



// WEBPACK FOOTER //
// src/components/BaseMap.vue